<template>
    <div class="yh-page">
      <el-card class="pt-3" v-loading="loading" :element-loading-text="loadingText">
        <el-form :rules="rules" ref="dataForm" :model="new_contact" label-position="right" label-width="160px">
        <!-- 联系人信息 ------------------------------------------------------------------------------ -->
          <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">联系人信息</span></el-divider>
            </el-col>
          </el-row>
  
          <el-row>
            <el-col :span="12">
              <!-- 姓名 -->
              <el-form-item label="姓名" prop="name">
                <el-input v-model="new_contact.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="new_contact.gender">
                  <el-radio v-for="gender in gender_list" :key="gender.code" :label="gender.code">{{ gender.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 手机号 -->
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="new_contact.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 固话-->
              <el-form-item label="固定电话" prop="phone">
                <el-input v-model="new_contact.phone" placeholder="请输入固定电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 邮箱 -->
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="new_contact.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 微信 -->
              <el-form-item label="微信" prop="wechat">
                <el-input v-model="new_contact.wechat" maxlength="11" placeholder="请输入微信号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 地址-->
              <el-form-item label="地址" prop="address">
                <el-input v-model="new_contact.address" placeholder="请输入地址"></el-input>
              </el-form-item>
            </el-col>
            <!-- 管理人-->
            <el-col :span="12">
              <el-form-item label="管理人" prop="owner">
                <el-select v-model="new_contact.owner" filterable placeholder="请选择管理人" :disabled="pageStatus==='action.edit' && !isOwn" class="w-100">
                  <el-option
                    v-for="(user, index) in user_list"
                    :key="index"
                    :label="user.first_name"
                    :value="user.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        <!-- 享有人信息 ------------------------------------------------------------------------------ -->
          <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">享有人信息</span></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系人享有人" prop="assistants">
                <el-select class="w-100" v-model="new_contact.assistants" filterable multiple :disabled="pageStatus==='action.edit' && !isOwn"
                          placeholder="请选择联系人享有人">
                  <el-option v-for="user in user_list" :key="user.id" :label="user.first_name"
                            :value="user.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        <!-- 绑定客户信息 ------------------------------------------------------------------------------ -->
          <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">绑定客户信息</span></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-button type="primary" size="small"  @click="handleBindCustomer">绑定客户</el-button>
              &nbsp;&nbsp;
              <el-button type="primary" size="small" @click="handUpdateCustomerList" v-if="pageStatus==='action.edit'">保存客户列表</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="22">
              <el-table :key="0" :data="customer_list" stripe fit class="w-100">
                <!-- 客户名称 -->
                <el-table-column align="left" label="姓名" min-width="120px">
                  <template slot-scope="scope">
                    <span class="font-weight-bold">{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="权限" min-width="120px">
                  <template slot-scope="scope">
                    <el-checkbox-group v-model="scope.row.permission">
                      <el-checkbox v-for="item in permission_list" :label="item.code" :key="item.code" disabled>{{item.value}}</el-checkbox>
                    </el-checkbox-group>
                  </template>
                </el-table-column>
                <!-- 按钮组 -->
                <el-table-column align="left" label="操作">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="解绑" placement="top-start">
                      <el-button
                                type="text" @click="handleCustomerRemove(scope.row)"><i class="el-icon-delete"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="border-top mt-2 pt-3">
              <el-form-item>
                <el-button size="small" @click="cancelData">取消</el-button>
                <el-button v-if="pageStatus == 'action.edit' && $perm(['contact.change_contact'])" size="small"
                           type="primary" @click="updateData">保存
                </el-button>
                <template v-if="pageStatus == 'action.add' && $perm(['contact.add_contact'])">
                  <el-button size="small" type="primary" @click="createData(1)">保存</el-button>
                  <el-button size="small" type="primary" @click="createData(2)">保存并新增</el-button>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-dialog :visible.sync="bindCustomerVisible" width="50%">
        <el-form ref="customerInfoForm" :model="selectBindCustomer" label-width="120px">
          <el-form-item label="选择客户">
            <el-select placeholder="搜索并选择客户" filterable remote reserve-keyword :loading="customer_loading" @change="changeSelectBindCustomerId"
                      :remote-method="remoteCustomerMethod" v-model="selectBindCustomer_id" value-key="id" class="w-75">
              <el-option v-for="item in other_customer_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" width="50%">
            <el-input v-model="selectBindCustomer.name" disabled></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="bindCustomer">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
    import {isValidMobileNumber} from '@/utils/validate'
    import {createContact, fetchContact, updateContact, fetchContactCustomerList, updateContactCustomerList} from '@/api/contact'
    import {fetchDictList, fetchUserList} from '@/api/common'
    import {fetchCustomerList} from '@/api/customer'
  
    export default {
      name: "detail",
      components: {
      },
      computed: {
      },
      data() {
        var contactFillingStatus = () => {
          let mobile = ''
          if (this.new_contact.mobile !== undefined && this.new_contact.mobile !== null && this.new_contact.mobile !== ''){
            mobile = this.new_contact.mobile.trim()
          }
          let phone = ''
          if (this.new_contact.phone !== undefined && this.new_contact.phone !== null && this.new_contact.phone !== ''){
            phone = this.new_contact.phone.trim()
          }
  
          if (mobile === '' && phone === ''){
            // 没有填写客户手机, 也没填写联系人
            return 'ALL_BLANK' 
          } else if (mobile !== '') {
            // 填写了客户手机号
            return 'FILLED_MOBILE'
          } else {
            return 0
          }
        };
  
        var checkMobile = (rule, value, callback) => {
          let status = contactFillingStatus()
          switch(status) {
            case 'ALL_BLANK': 
              return callback(new Error('联系人手机号或固话需要至少填写一项'));
              break;
            case 'FILLED_MOBILE':
              if (!isValidMobileNumber(value)) {
                return callback(new Error('手机格式不正确'))
              }
              return callback();
              break;
            default:
              return callback()
          }
        };
  
        var checkContactName = (rule, value, callback) => {
          var reg = new RegExp("[`~!@#$^&*=|{}':;',\\[\\].<>/?~！@#￥……&*——|{}【】‘；：”“'。，、？]", "g")
  
          if (value == undefined || value == null || value == "") {
            return callback(new Error("请输入客户名称"))
          }
          else if (value.length > 4) {
            return callback(new Error("个人名称不得超过4个字"))
          }
          else if (reg.test(value)) {
            return callback(new Error("名称不能含有特殊字符"))
          }
          else {
            return callback()
          }
        };
  
        return {
          rules: {
            name: [{required: true, trigger: 'blur', validator: checkContactName}],
            mobile: [{validator: checkMobile, trigger: 'blur'}],
            owner: [{required: true, message: '请选择管理人', trigger: 'blur'}],
          },
          loading: false,
          loadingText: '正在加载数据，请销等...',
          new_contact: {
            name: '',
            gender: null,
            mobile: '',
            phone: '',
            email: '',
            wechat: '',
            address: '',
            owner: null,
          },
          pageStatus: '',
          gender_list: [],
          user_list: [],
          customer_list: [],
          permission_list: [],
          bindCustomerVisible: false,
          customer_loading: false,
          other_customer_list: [],
          selectBindCustomer: {},
          selectBindCustomer_id: '',
        }
      },
      computed: {
        isOwn: function () {
          let is_superuser = this.$store.getters.is_superuser
          return (
            is_superuser ||
            !this.new_contact.owner ||
            this.$store.state.user.user === this.new_contact.owner
          );
        },
      },
      methods: {
        loadData() {
          let p1 = fetchDictList({type: 'contact.gender'})
          let p2 = fetchUserList()
          let p3 = fetchDictList({type: 'contact_customer.permission'})

          this.loading = true
          Promise.all([p1, p2, p3])
            .then(res => {
              this.gender_list = res[0]
              this.user_list = res[1]
              this.permission_list = res[2]
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              this.$message.error(error)
            })
        },
        reset_new_contact() {
          this.new_contact = {}
        },
        handleCreate() {
          this.pageStatus = 'action.add'
          this.loadData()
        },
        handleUpdate(id) {
          this.pageStatus = 'action.edit'
          this.loadData()
          let login_userid = this.$store.state.user.user
          let p1 = fetchContact(id)
          let p2 = fetchContactCustomerList(id)
          Promise.all([p1, p2])
            .then(res => {
              this.new_contact = Object.assign({}, res[0])
  
              if(!this.new_contact.customers) {
                this.$set(this.new_contact, 'customers', [])
              }
              if(!this.new_contact.assistants) {
                this.$set(this.new_contact, 'assistants', [])
              }

              this.customer_list = res[1]
  
              this.$nextTick(() => {
                this.$refs['dataForm'].clearValidate()
              })
            })
            .catch(error => {
              this.$message.error(error)
            })
        },
        handleOpen() {
          this.$refs.upload.handleOpen()
        },
        cancelData() {
          this.$refs.dataForm.resetFields()
          this.reset_new_contact()
          this.$router.push({name: 'contactList'})
        },
        createData(type) {
          this.$refs['dataForm'].validate(valid => {
            if (valid) {
              let proArr = []
              this.loading = true
              this.loadingText = '正在保存联系人数据，请稍等...'
              createContact(this.new_contact)
                .then(res => {
                  this.contactid = res.id
                  console.log(this.customer_list)
                  if (this.customer_list.length > 0) {
                    proArr.push(updateContactCustomerList(this.contactid, {'customer_list': this.customer_list}))
                  }
                  return Promise.all(proArr)
                }).then(() => {
                  this.loading = false
                  this.$message.success('保存联系人信息成功')
                  this.$nextTick(() => {
                    this.$refs.dataForm.clearValidate()
                    this.$refs.dataForm.resetFields()
                    this.reset_new_contact()
                    this.$router.push({name: 'contactList'})
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$message.error(error)
                })
            }
  
            // this.$message.error('校验失败!')
          })
        },
        updateData() {
          this.$refs.dataForm.validate((valid) => {
            if (valid) {
              this.loading = true
              const new_contact = Object.assign({}, this.new_contact)
              updateContact(new_contact.id, new_contact)
                .then(() => {
                  this.$message.success('更新联系人信息成功')
                  this.$nextTick(() => {
                    this.loading = false
                    this.$refs.dataForm.clearValidate()
                    this.$refs.dataForm.resetFields()
                    this.reset_new_contact()
                    setTimeout(() => {
                      this.$router.push({name: 'contactList'})
                    }, 2000)
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$message.error(error)
                })
            }
          })
        },
        handleBindCustomer() {
          this.bindCustomerVisible = true
        },
        remoteCustomerMethod(query) {
          if (query !== '') {
            this.customer_loading = true
            setTimeout(() => {
              fetchCustomerList({'search': query}).then(res => {
                this.other_customer_list = res
                this.customer_loading = false
              }).catch(err => {
                this.customer_loading = false
                this.$error_message(err)
              })
            }, 200);
          } else {
            this.other_customer_list = [];
          }
        },
        changeSelectBindCustomerId(val) {
          var find_item = this.other_customer_list.find(item => item.id===val)
          this.$set(this.selectBindCustomer, 'id', find_item.id)
          this.$set(this.selectBindCustomer, 'name', find_item.name)
        },
        bindCustomer() {
          if (this.selectBindCustomer_id === undefined || this.selectBindCustomer_id === null || this.selectBindCustomer_id === '') {
            this.$message.error('请选择客户')
          } else if (this.customer_list.find(item => item.id===this.selectBindCustomer_id) !== undefined) {
            this.$message.error('客户【'+ this.selectBindCustomer.name +'】已绑定')
          } else {
            this.customer_list.push({'id': this.selectBindCustomer.id, 'name': this.selectBindCustomer.name, 'permission': []})
            this.$refs.customerInfoForm.resetFields()
            this.bindCustomerVisible = false
          }
        },
        handUpdateCustomerList() {
          this.loading = true
          updateContactCustomerList(this.contactid, {'customer_list': this.customer_list}).then(() => {
            this.loading = false
            this.$message.success('保存客户列表成功')
          }).catch(err => {
            this.loading = false
            this.$message.error(err)
          })
        },
        handleCustomerRemove(row) {
          var msg = '是否移除客户 ' + row.name + ' ？'
            this.$confirm(msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              var target = this.customer_list.indexOf(row)
              this.customer_list.splice(target, 1)
            })
        },
      },
      beforeRouteLeave (to, from, next) {
          if (to.name != 'contactList') {
            window.localStorage.removeItem('query')
          }
          next()
          },
      created() {
        if (this.$route.name == 'contactCreate') {
          this.handleCreate()
        } else {
          var id = this.$route.query.id
          if (id == undefined) {
            this.$router.push('/404')
          } else {
            this.contactid = id
            this.handleUpdate(this.contactid)
          }
        }
      }
    }
  </script>
  
  <style scoped>
  .el-row-divider {
    margin-top: 36px
  }
  
  .title {
    font-weight: bold;
  }
  
  .highlight {
    color:red;
  }
  
  </style>      